import { PrintType } from '@/types';
import { Flex, Flock, SpecialFlex } from '@/model/printType/printTypes';
import { getIsRealisticFlexColor } from './getIsRealisticFlexColor';

export function getIsSpecialPatternColor({ id: printTypeId }: PrintType, printColorId?: string) {
  return Boolean(
    printColorId &&
      (printTypeId === Flock ||
        printTypeId === SpecialFlex ||
        (printTypeId === Flex && getIsRealisticFlexColor(printColorId)))
  );
}
